import React, { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';

interface SearchEvent {
    completed: boolean;
    results: string[];
    search_message: string;
}

interface ChatContainerProps {
    messages: { id: string, role: string, content: string, searchEvent: SearchEvent | null}[];
    currentMessage: string;
    currentSearchEvent: SearchEvent | null;
}

const ChatContainer: React.FC<ChatContainerProps> = ({ messages, currentMessage, currentSearchEvent }) => {
    const chatWindowRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (chatWindowRef.current) {
            chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
        }
    }, [messages, currentMessage, currentSearchEvent]);

    return (
        <div className="pr-4 flex-auto sm:h-[474px] overflow-y-auto" ref={chatWindowRef}>
            {messages.map((msg, index) => (
                <ChatMessage key={index} role={msg.role as 'user' | 'assistant'} content={msg.content} searchEvent={msg.searchEvent} />
            ))}
            {currentMessage && (
                <ChatMessage role="assistant" content={currentMessage} searchEvent={currentSearchEvent} />
            )}
        </div>
    );
};

export default ChatContainer;